const admin = require('./json/admin.json')

export { admin }
